import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useVenue } from '../context/VenueContext';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Building2, UtensilsCrossed, Pizza, Wine, ChevronsUpDown } from 'lucide-react';
import { cn } from '../lib/utils';

const tipoIcon = (tipo) => {
  if (tipo === 'pizzeria') return Pizza;
  if (tipo === 'bar') return Wine;
  if (tipo === 'ristorante') return UtensilsCrossed;
  return Building2;
};

/**
 * Indicatore del locale attivo da mettere nell'header di ogni pagina operativa.
 * Mostra logo/icona + nome. Se l'utente ha 2+ locali (o è super_admin), include
 * un pulsante "Cambia" che riporta a /seleziona-locale.
 */
const VenueBadge = ({ className }) => {
  const navigate = useNavigate();
  const { activeVenue, availableVenues, clearVenue } = useVenue();
  const { isSuperAdmin } = useAuth();

  if (!activeVenue) return null;
  const Icon = tipoIcon(activeVenue.tipo);
  const canSwitch = availableVenues.length > 1 || isSuperAdmin();

  const handleSwitch = () => {
    clearVenue();
    navigate('/seleziona-locale');
  };

  return (
    <div className={cn('flex items-center gap-2 min-w-0', className)} data-testid="venue-badge">
      <div className="w-7 h-7 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
        {activeVenue.logo ? (
          <img src={activeVenue.logo} alt={activeVenue.nome} className="w-7 h-7 rounded-full object-cover" />
        ) : (
          <Icon className="w-4 h-4 text-primary" />
        )}
      </div>
      <span className="text-sm font-semibold truncate" data-testid="active-venue-name">{activeVenue.nome}</span>
      {canSwitch && (
        <Button
          variant="ghost"
          size="sm"
          className="h-7 px-2 text-xs gap-1"
          onClick={handleSwitch}
          data-testid="switch-venue-btn"
        >
          <ChevronsUpDown className="w-3.5 h-3.5" /> Cambia
        </Button>
      )}
    </div>
  );
};

export default VenueBadge;
